import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, ShadowTypeTokens, SizeTypeTokens, StackAlignContent, StackAlignItems, StackJustifyContent, StackPositionType, StackSelfContent, StackType, StackWidth, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { getMoreMfPortfolio, goBackAction, mfcFetchRefreshAction, needHelp, portfolioListDatastoreBuilder, } from "./action";
import SharedPropsService from "../../../SharedPropsService";
import { addCommasToNumber, getDateMonthYearFromEpochFromMicroseconds, } from "../../../configs/utils";
import { fetchPledgeLimitRepo } from "../unlock_limit/repo";
import { Platform } from "react-native";
import { AssetRepositoryType, isDarkModeTheme } from "../../../configs/config";
let isDarkMode = isDarkModeTheme();
export const template = async (stepResponseObject, formattedDate, availableAmount, totalPortfolio, assetRepository, isFromMFCentral) => ({
    layout: {
        id: ROUTE.PORTFOLIO_FROM_RTA,
        type: LAYOUTS.LIST,
        widgets: [
            Platform.OS === 'ios' ? { id: "spaceXXL", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
            {
                id: "customHeader",
                type: WIDGET.CUSTOM_HEADER,
                position: POSITION.ABSOLUTE_TOP,
            },
            {
                id: "headerDivider",
                type: WIDGET.DIVIDER,
                position: POSITION.ABSOLUTE_TOP
            },
            {
                id: "creditLimitStack1",
                type: WIDGET.STACK,
                padding: {
                    horizontal: -16
                }
            },
            {
                id: "space",
                type: WIDGET.SPACE,
            },
            { id: "text", type: WIDGET.TEXT },
            { id: "space2", type: WIDGET.SPACE },
            { id: "mfStack", type: WIDGET.STACK },
            { id: "space3", type: WIDGET.SPACE },
            { id: "divider", type: WIDGET.DIVIDER },
            { id: "listItem", type: WIDGET.LIST },
            { id: "ctaStackDivider",
                type: WIDGET.DIVIDER,
                position: POSITION.STICKY_BOTTOM,
                padding: { horizontal: 0 }
            },
            { id: "ctaStack", type: WIDGET.STACK, position: POSITION.STICKY_BOTTOM },
            { id: "space3", type: WIDGET.SPACE },
            { id: "space3", type: WIDGET.SPACE },
        ],
    },
    datastore: {
        ctaStackDivider: {
            size: DividerSizeTokens.MD,
            color: ColorTokens.Grey_Milk_1
        },
        customHeader: {
            title: isFromMFCentral ? "Your mutual funds" : assetRepository === "KARVY"
                ? `Portfolio from KFintech`
                : `Portfolio from ${assetRepository}`,
            isDarkMode: isDarkMode ? true : false,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.PORTFOLIO_FROM_RTA,
                payload: {
                    id: "btn_portfolioRTA_goBack"
                },
            },
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.PORTFOLIO_FROM_RTA,
                isDarkMode: isDarkMode ? true : false,
                payload: {
                    id: "btn_portfolioRTA_needHelp"
                },
            }
        },
        spaceXXL: {
            size: SizeTypeTokens.XXL
        },
        headerDivider: {
            color: ColorTokens.Grey_Milk_1,
            size: DividerSizeTokens.SM,
        },
        creditLimitStack1: {
            width: StackWidth.MATCH_PARENT,
            bgColor: isDarkMode ? ColorTokens.BACKGROUND_DARK_1 : ColorTokens.Primary_05,
            padding: {
                top: SizeTypeTokens.XL,
                left: SizeTypeTokens.LG,
                right: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.XL,
            },
            positionConfig: {
                bottom: SizeTypeTokens.XL
            },
            position: StackPositionType.relative,
            widgetItems: [
                {
                    id: "creditLimitStack",
                    type: WIDGET.STACK,
                },
            ],
        },
        creditLimitStack: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.row,
            bgColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White,
            padding: {
                top: SizeTypeTokens.LG,
                left: SizeTypeTokens.LG,
                right: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG,
            },
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR3,
                borderWidth: {
                    all: SizeTypeTokens.XS,
                },
                borderColor: ColorTokens.Grey_Milk_1
            },
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: "head", type: WIDGET.STACK },
                { id: "headSpace", type: WIDGET.SPACE },
                { id: "tail", type: WIDGET.STACK },
            ],
        },
        headSpace: {
            size: SizeTypeTokens.XXXXXXL
        },
        head: {
            width: StackWidth.CONTENT,
            type: StackType.column,
            widgetItems: [
                { id: "Value", type: WIDGET.TEXT },
                { id: 'headSpace0', type: WIDGET.SPACE },
                { id: "Value2", type: WIDGET.TEXT },
            ],
        },
        headSpace0: {
            size: SizeTypeTokens.MD
        },
        headSpace1: {
            size: SizeTypeTokens.MD
        },
        tail: {
            width: StackWidth.CONTENT,
            type: StackType.column,
            widgetItems: [
                { id: "AvailableCreditLimit", type: WIDGET.TEXT },
                { id: 'headSpace1', type: WIDGET.SPACE },
                { id: "AvailableCreditLimit2", type: WIDGET.TEXT },
            ],
        },
        AvailableCreditLimitSpace: {
            size: SizeTypeTokens.LG,
        },
        Value: {
            label: `Value`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "100",
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal,
            fontSize: FontSizeTokens.SM,
            lineHeight: 16,
        },
        AvailableCreditLimit: {
            label: `Available credit limit`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "100",
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal,
            fontSize: FontSizeTokens.SM,
            lineHeight: 18,
        },
        Value2: {
            label: `₹${addCommasToNumber(totalPortfolio)}`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "800",
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal,
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
        },
        AvailableCreditLimit2: {
            label: `₹${addCommasToNumber(availableAmount)}`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "800",
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal,
            fontSize: FontSizeTokens.XS,
            lineHeight: 16,
        },
        space: {
            size: SizeTypeTokens.XL,
        },
        text: {
            label: `Credit limit by mutual fund`,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: Platform.OS !== "web" ? "600" : "400",
            fontSize: FontSizeTokens.MD,
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
        },
        space2: {
            size: SizeTypeTokens.XL,
        },
        mfStack: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.row,
            justifyContent: StackJustifyContent.spaceBetween,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "mfText", type: WIDGET.TEXT },
                { id: "mfText2", type: WIDGET.TEXT },
            ],
        },
        mfText: {
            label: `Mutual fund`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
            fontSize: FontSizeTokens.XS,
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
        },
        mfText2: {
            label: `Available credit limit`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
            fontSize: FontSizeTokens.XS,
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night
        },
        space3: {
            size: SizeTypeTokens.MD,
        },
        divider: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Milk_1,
        },
        ...(await portfolioListDatastoreBuilder(stepResponseObject, assetRepository, "", isFromMFCentral)),
        ctaStack: {
            padding: {
                bottom: Platform.OS === 'web' ? SizeTypeTokens.NONE : SizeTypeTokens.LG,
                left: SizeTypeTokens.LG,
                right: SizeTypeTokens.LG
            },
            width: StackWidth.MATCH_PARENT,
            type: StackType.column,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            alignSelf: StackSelfContent.center,
            alignContent: StackAlignContent.center,
            shadow: ShadowTypeTokens.E1,
            widgetItems: [
                { id: "ctaSpace", type: WIDGET.SPACE },
                { id: "ctaTextStack", type: WIDGET.STACK },
                { id: "ctaSpace", type: WIDGET.SPACE },
                { id: "ctaButton", type: WIDGET.BUTTON },
                { id: "ctaSpace", type: WIDGET.SPACE },
                { id: "ctaSpace", type: WIDGET.SPACE },
            ],
        },
        ctaTextStack: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.row,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "ctaText1", type: WIDGET.TEXT },
                { id: "ctaSpace2", type: WIDGET.SPACE },
                { id: "ctaText2", type: WIDGET.TEXT },
            ],
        },
        ctaText1: {
            label: `Last fetched on`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
            fontSize: FontSizeTokens.XS,
            color: ColorTokens.Grey_Charcoal,
        },
        ctaSpace2: {
            size: SizeTypeTokens.SM,
        },
        ctaText2: {
            label: `${formattedDate}`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "800",
            fontSize: FontSizeTokens.XS,
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
        },
        ctaSpace: {
            size: SizeTypeTokens.MD,
        },
        ctaButton: {
            id: 'bt_refreshPortfolio_refreshPortfolio',
            label: `Refresh portfolio`,
            width: ButtonWidthTypeToken.FULL,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "700",
            isDarkMode: isDarkMode ? true : false,
            type: isDarkMode ? ButtonTypeTokens.LargeSoftFilled : ButtonTypeTokens.LargeFilled,
            fontSize: FontSizeTokens.SM,
            shouldShowHighlight: false,
            action: assetRepository === AssetRepositoryType.MFCENTRAL ? {
                type: ACTION.MFC_FETCH_REFRESH,
                payload: {},
                routeId: ROUTE.PORTFOLIO_FROM_RTA,
            }
                : {
                    type: ACTION.GET_MORE_MF_PORTFOLIO,
                    payload: {
                        casList: stepResponseObject.availableCAS,
                        assetRepository: assetRepository,
                    },
                    routeId: ROUTE.PORTFOLIO_FROM_RTA,
                },
        },
    },
});
export const portfoliofromRTAMf = {
    onLoad: async (_, { assetRepository, isFromMFCentral }) => {
        _.instrumentTrack("FETCHED_MUTUAL_FUNDS_SCREEN_VIEWED");
        const updateAvailableCASMap = {};
        const authCAS = await SharedPropsService.getAuthCASResponse();
        console.warn("AUTH CAS IS", authCAS);
        const pledgeLimitResponse = authCAS
            ? { data: authCAS }
            : await fetchPledgeLimitRepo().then((response) => ({
                data: response,
            }));
        /*** update authCAS in SharedPropsService if fetched from api ***/
        await SharedPropsService.setAuthCASResponse(pledgeLimitResponse.data);
        const availableCAS = pledgeLimitResponse.data.stepResponseObject.availableCAS || [];
        await SharedPropsService.setCasListOriginal(availableCAS);
        const stepResponseObject = pledgeLimitResponse.data.stepResponseObject;
        const date = assetRepository === AssetRepositoryType?.CAMS
            ? stepResponseObject?.repositoryAssetMetadataMap?.CAMS?.casFetchDate
            : assetRepository === AssetRepositoryType.MFCENTRAL ? stepResponseObject?.repositoryAssetMetadataMap?.MFCENTRAL?.casFetchDate : stepResponseObject?.repositoryAssetMetadataMap?.KARVY?.casFetchDate;
        const formattedDate = getDateMonthYearFromEpochFromMicroseconds(date);
        const availableAmount = assetRepository === AssetRepositoryType.CAMS
            ? stepResponseObject?.repositoryAssetMetadataMap?.CAMS?.availableCreditAmount
            : assetRepository === AssetRepositoryType.MFCENTRAL ? stepResponseObject?.repositoryAssetMetadataMap?.CAMS?.availableCreditAmount
                + stepResponseObject?.repositoryAssetMetadataMap?.KARVY?.availableCreditAmount
                : stepResponseObject?.repositoryAssetMetadataMap?.KARVY?.availableCreditAmount;
        const totalPortfolio = assetRepository === AssetRepositoryType.CAMS
            ? stepResponseObject?.repositoryAssetMetadataMap?.CAMS?.availablePortfolioAmount
            : assetRepository === AssetRepositoryType.MFCENTRAL ? stepResponseObject?.repositoryAssetMetadataMap?.CAMS?.availablePortfolioAmount
                + stepResponseObject?.repositoryAssetMetadataMap?.KARVY?.availablePortfolioAmount
                : stepResponseObject?.repositoryAssetMetadataMap?.KARVY?.availablePortfolioAmount;
        /*** Prefill pledgeUnit ***/
        stepResponseObject.availableCAS.map((item, index) => {
            let key = `${item.isinNo}-${item.folioNo}`;
            item.pledgedUnits = item.totalAvailableUnits;
            updateAvailableCASMap[key] = item;
        });
        return Promise.resolve(template(stepResponseObject, formattedDate, availableAmount, totalPortfolio, assetRepository, isFromMFCentral));
    },
    actions: {
        [ACTION.GO_BACK]: goBackAction,
        [ACTION.GET_MORE_MF_PORTFOLIO]: getMoreMfPortfolio,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.MFC_FETCH_REFRESH]: mfcFetchRefreshAction,
    },
};
